export default "__VITE_ASSET__CeWQZxtp__"